import application_contants from "../../constants/application_contant";
import { ActionTypes } from "../constants/action-types"

const initialState = {
    direction: application_contants.NONE,
}


export const directionReducer = (state = initialState, { type, payload }) => {
    switch (type) {
        case ActionTypes.SET_DIRECTION:
            return { ...state, direction: payload };
        default:
            return state;
    }
}
